export const getBrandRewardsPayloadSchema = {
    type: 'object',
    properties: {
        limit: { type: 'integer' },
        section: { type: 'string' },
        brandId: { type: 'string' },
        // Drop whose own reservations should be left out of `freeCapacity` (the drop being edited in
        // the add-campaign wizard). Must stay declared here: the schema is additionalProperties: false.
        excludeDropId: { type: 'string' },
        filter: {
            type: 'object',
            properties: {
                freeToReserve: { type: 'boolean' },
            },
        },
    },
    required: [],
    additionalProperties: false,
};
